/** 指标采集器（设计文档 3.7 / metrics/collector.ts）。增量更新，支撑实时仪表盘。 */
import { segmentEnergyJ } from './energy-model';

export interface MetricsSummary {
  deliveredCount: number;
  waitingCount: number;
  ridingCount: number;
  avgWaitMs: number;
  maxWaitMs: number;
  avgRideMs: number;
  maxRideMs: number;
  throughputPerHour: number;
  carUtilization: number; // 0..1
  energyKwh: number;
}

/** 指标时间序列采样点（F-018）。 */
export interface SeriesPoint {
  readonly tMs: number;
  readonly avgWaitMs: number;
  readonly waiting: number;
  readonly throughputPerHour: number;
}

export class MetricsCollector {
  private delivered = 0;
  private waitSum = 0;
  private waitMax = 0;
  private rideSum = 0;
  private rideMax = 0;

  // 利用率：Σ(载客数·运行ms) / Σ(容量·运行ms)
  private utilNumerator = 0;
  private utilDenominator = 0;

  private energyJ = 0;
  private simEndMs = 0;

  waiting = 0; // 当前候梯人数
  riding = 0; // 当前乘梯人数

  recordPassengerArrived(): void {
    this.waiting++;
  }

  recordBoarded(waitMs: number): void {
    this.waiting--;
    this.waitSum += waitMs;
    if (waitMs > this.waitMax) this.waitMax = waitMs;
    this.riding++;
  }

  recordAlighted(rideMs: number): void {
    this.riding--;
    this.delivered++;
    this.rideSum += rideMs;
    if (rideMs > this.rideMax) this.rideMax = rideMs;
  }

  /** 记录一段轿厢运行（载客 load，运行 runMs，距离 distanceM）。 */
  recordSegment(
    capacity: number,
    load: number,
    runMs: number,
    distanceM: number,
    goingDown: boolean,
    carMassKg: number,
  ): void {
    this.utilNumerator += load * runMs;
    this.utilDenominator += capacity * runMs;
    this.energyJ += segmentEnergyJ(distanceM, load, capacity, goingDown, carMassKg);
  }

  setSimEnd(ms: number): void {
    this.simEndMs = ms;
  }

  /** 在任意仿真时刻的指标快照（运行中也有效，供 F-018 时序采样）。 */
  summaryAt(nowMs: number): MetricsSummary {
    const hours = nowMs / 3_600_000;
    return {
      deliveredCount: this.delivered,
      waitingCount: this.waiting,
      ridingCount: this.riding,
      avgWaitMs: this.delivered ? this.waitSum / this.delivered : 0,
      maxWaitMs: this.waitMax,
      avgRideMs: this.delivered ? this.rideSum / this.delivered : 0,
      maxRideMs: this.rideMax,
      throughputPerHour: hours > 0 ? this.delivered / hours : 0,
      carUtilization: this.utilDenominator > 0 ? this.utilNumerator / this.utilDenominator : 0,
      energyKwh: this.energyJ / 3_600_000,
    };
  }

  summary(): MetricsSummary {
    return this.summaryAt(this.simEndMs);
  }
}
